import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconChatAdd$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconChatAdd extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'b3e1d9ef9d900b6c2f88456318c1f871a42f6316', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '743e5427b8e2d25a583ef6c219b587e61a550ed4', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '3be98b7db3b43e312045c65d91f660728e0025ae', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M20 3H2.5a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5H7v4.36a.3.3 0 0 0 .49.23L13 15h6.5a.5.5 0 0 0 .5-.5zm-1.5 1.5v9h-5.86a.47.47 0 0 0-.32.12L8.5 16.8V14a.5.5 0 0 0-.5-.5H3.5v-9zm-6.75 3.75h1.75a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-1.75v1.75a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5V9.75H8.5a.5.5 0 0 1-.5-.5v-.5a.5.5 0 0 1 .5-.5h1.75V6.5a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-chat-add", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-chat-add"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-chat-add":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconChatAdd$1);
            }
            break;
    } });
}

const CosmosIconChatAdd = CosmosIconChatAdd$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconChatAdd, defineCustomElement };
